import React from 'react';
import { motion } from 'framer-motion';
import Hotkeys from 'react-hot-keys';
import { Image, notification } from 'antd';
import { tickIcon } from '../common/Icons';

const dhissteps = [
    {
        text:
            '<p>Click on the button <b>“Go to registration page”</b> or go to <a href="https://facility.ndhm.gov.in/" target="_blank" class="text-darwin-accent-bright-blue-800 font-700">https://facility.ndhm.gov.in/</a>. <br /><br /> Select <b>“Old Portal”</b> to start your registration process.</p>',
        images: ['/images/dhis-incentive/image-1.webp'],
    },
    { text: '<p>Login via mobile or HPR ID.</p>', images: ['/images/dhis-incentive/image-2.webp'] },
    {
        text:
            '<p>Under your <b>“Health Facility”</b> click on the button <b>“Register for DHIS”</b>.</p>',
        images: ['/images/dhis-incentive/image-3.webp'],
    },
    {
        text:
            '<p>Your registration has now started. Download the <b>“Mandate Form”</b> and <b>“Annexure-4”</b> and fill them up.<br /><br />You can print these forms, fill them and click their photos to upload later, or you can use any PDF editor to fill the downloaded forms directly.<br /><br />Click on <b>“Proceed”</b> to continue.</p>',
        images: ['/images/dhis-incentive/image-4.webp'],
    },
    {
        text: '<p>Fill out your DHIS registration form.</p>',
        images: ['/images/dhis-incentive/image-5.webp'],
    },
    {
        text:
            '<p>Upload the filled forms from previous step along with a cancelled cheque and PAN card</p>',
        images: ['/images/dhis-incentive/image-6.webp'],
    },
    {
        text:
            '<p>Verify your Aadhar number to submit your DHIS registration.<br /><br />Once submitted, a DHIS registration summary will be downloaded. You will also receive a confirmation mail on your registered E-mail id.</p>',
    },
];

const claimincentivesteps = [
    {
        text:
            '<p>Click on the button <b>"claim now”</b> or go to <a href="https://facility.ndhm.gov.in/" class="text-darwin-accent-bright-blue-800 font-700" target="_blank">https://facility.ndhm.gov.in/</a>.<br /><br />Select <b>“Old Portal”</b> to login.</p>',
        images: ['/images/dhis-incentive/claim-image-1.webp'],
    },
    {
        text: '<p>Login via mobile or HPR ID.</p>',
        images: ['/images/dhis-incentive/claim-image-2.webp'],
    },
    {
        text:
            '<p>Under your <b>“Health Facility”</b> click on the button <b>“Register for DHIS”</b>.</p>',
        images: ['/images/dhis-incentive/claim-image-3.webp'],
    },
    {
        text:
            '<p>Click on <b>“Claim your incentives”</b> from the left menu to view your eligible incentives and their status.<br /><br />For the incentive to be claimed - click on <b>“e-sign”</b>, and verify your Aadhaar number. This is will provide authorisation for incentive claim.</p>',
        images: [
            '/images/dhis-incentive/claim-image-4.webp',
            '/images/dhis-incentive/claim-image-4-1.webp',
        ],
    },
    {
        text:
            '<p>Once verified, the claim button turns <span class="font-700 text-darwin-green-primary">Green</span>. Click on <b>“Claim”</b> button and then on <b>“Ok”<b/> button in the confirmation pop-up to claim the incentive.</p>',
        images: [
            '/images/dhis-incentive/claim-image-5.webp',
            '/images/dhis-incentive/claim-image-5-1.webp',
            '/images/dhis-incentive/claim-image-5-2.webp',
        ],
    },
];

const ABHAStepsModal: React.FC<{
    close: () => void;
    claimModal?: boolean;
    onMark: (onSuccess?: () => void, onFailure?: () => void) => void;
    markText: string;
}> = ({ close, claimModal, onMark, markText }) => {
    const steps = claimModal ? claimincentivesteps : dhissteps;

    const onMarkSuccess = () => {
        close();
        notification.success({
            message: `Status updated!`,
            duration: 2,
        });
    };

    const onMarkFailure = () => {
        close();
        notification.error({
            message: `Error occured updating status`,
            duration: 2,
        });
    };

    return (
        <Hotkeys keyName="esc" onKeyDown={close}>
            <motion.div
                initial={{ opacity: 0 }}
                exit={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                style={{ zIndex: 20 }}
                transition={{ duration: 0.2, ease: 'linear' }}
                className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 font-lato"
            >
                <div className="modal-overlay" onClick={close}></div>
                <div className="modal-content bg-darwin-neutral_new-50 w-60p h-3/4 flex flex-col">
                    <div className="flex items-center border-b border-darwin-neutral_new-200 justify-between p-16 rounded-t-4 bg-white">
                        <p className="text-20">
                            {claimModal
                                ? 'Steps to claim DHIS incentives'
                                : 'Steps to submit registration for the DHIS Scheme'}
                        </p>
                        <div
                            onClick={close}
                            className="flex items-center justify-center w-16 h-16 cursor-pointer"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 320 512"
                                className="w-16 h-16 fill-neutral-1"
                            >
                                <path d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
                            </svg>
                        </div>
                    </div>
                    <div className="w-full bg-darwin-neutral_new-50 flex-1 overflow-y-scroll">
                        {steps.map((step, idx) => (
                            <div className="flex gap-8 p-16">
                                <p className="self-start font-700 text-13">{idx + 1}.</p>
                                <div className="flex flex-col gap-16">
                                    <div
                                        className="text-14"
                                        dangerouslySetInnerHTML={{
                                            __html: step.text,
                                        }}
                                    ></div>
                                    {step.images?.length && (
                                        <div className="flex flex-col gap-16">
                                            {step.images.map((image) => (
                                                <Image
                                                    loading="lazy"
                                                    width={400}
                                                    src={image}
                                                    alt={`DHIS Step ${idx + 1}`}
                                                />
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="border-t border-darwin-neutral_new-200 gap-16 p-12 w-full flex justify-between items-center">
                        <div
                            onClick={close}
                            className="flex font-700 bg-white cursor-pointer rounded-8 hover:bg-darwin-accent-bright-blue-100 justify-center items-center py-8 px-16 border border-darwin-accent-bright-blue-800 text-darwin-accent-bright-blue-800"
                        >
                            Cancel
                        </div>

                        <div className="flex items-center gap-8">
                            <div
                                onClick={() =>
                                    window.open('https://facility.ndhm.gov.in/', '_blank')
                                }
                                className="flex font-700 cursor-pointer rounded-8 hover:opacity-60 gap-4 justify-center items-center py-8 px-16 bg-darwin-accent-bright-blue-800 text-white"
                            >
                                {claimModal ? 'Claim now' : 'Go to registration page'}
                            </div>
                        </div>
                    </div>
                </div>
            </motion.div>
        </Hotkeys>
    );
};

export default ABHAStepsModal;
